import { Controller, ControllerProps, useFormContext } from 'react-hook-form';

export interface RHFControllerProps {
  name: string;
  label?: React.ReactNode;
  controllerProps?: ControllerProps;
  helperText?: React.ReactNode;
}

export function withRHFController<P extends object>(
  Component: React.ComponentType<P>
): React.FC<RHFControllerProps & P> {
  return ({ controllerProps, ...props }) => {
    const context = useFormContext();

    if (!context && !controllerProps?.control) {
      throw new Error(
        `${Component.name} must be used within a FormProvider or with a "control" prop`
      );
    }

    return (
      <Controller
        {...controllerProps}
        control={controllerProps?.control ?? context.control}
        name={props.name}
        render={({ field, fieldState: { error } }) => {
          return (
            /* @ts-expect-error todo: come back and figure this out */
            <Component
              {...field}
              {...props}
              id={props.name}
              label={props.label}
              error={error?.message}
            />
          );
        }}
      />
    );
  };
}
